module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_vm._l((_vm.child_infos_chunk), function(child_infos) {
    return _c('div', {
      staticClass: "row mx-5-gutters child-select-area"
    }, _vm._l((child_infos), function(child_info) {
      return _c('div', {
        staticClass: "col-4"
      }, [_c('div', {
        staticClass: "child-select-item",
        staticStyle: {
          "height": "100%"
        }
      }, [_c('router-link', {
        staticClass: "btn btn-outline-success btn-child my-2 btn-child w-100 text-left",
        staticStyle: {
          "height": "80%"
        },
        attrs: {
          "tag": "button",
          "to": {
            name: 'mypage::child_info::detail',
            params: {
              child_info_id: child_info.id
            }
          }
        }
      }, [_vm._v("\n              " + _vm._s(child_info.family_name) + " " + _vm._s(child_info.given_name) + "\n            ")])], 1)])
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "form-list py-3"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.family_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][2]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.family_name),
      expression: "input.family_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Yamada"
    },
    domProps: {
      "value": (_vm.input.family_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.family_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.family_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.family_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_3'][1]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.given_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][3]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.given_name),
      expression: "input.given_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Taro"
    },
    domProps: {
      "value": (_vm.input.given_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.given_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.given_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.given_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_3'][2]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.school_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][4]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.school_name),
      expression: "input.school_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "oo school"
    },
    domProps: {
      "value": (_vm.input.school_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.school_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.school_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.school_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_3'][3]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.group_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][5]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.group_name),
      expression: "input.group_name"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "A"
    },
    domProps: {
      "value": (_vm.input.group_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.group_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.group_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_3'][4]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.family_relation_id.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][6]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.family_relation_id),
      expression: "input.family_relation_id"
    }],
    staticClass: "custom-select mb-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.input.family_relation_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.$v.input.family_relation_id.$touch()
      }]
    }
  }, _vm._l((_vm.family_relations), function(family_relation) {
    return _c('option', {
      domProps: {
        "value": family_relation.id
      }
    }, [_vm._v(_vm._s(family_relation.name))])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.family_relation_id,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_3'][5]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), (_vm.isShowAddBtn) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 col-5"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][7]"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][8]"
    }
  })], 1)])])]) : _c('div', [_c('div', {
    staticClass: "offset-3 col-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][8]"
    }
  })], 1)])])]), _vm._v(" "), (_vm.isShowAddBtn) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('p', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][9]"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn w-100 btn-lg btn-danger",
    attrs: {
      "tag": "button",
      "to": {
        name: 'mypage::child_info',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_3'][10]"
    }
  })], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('child-delete-confirm-modal', {
    attrs: {
      "input": _vm.input
    },
    on: {
      "remove": _vm.remove
    }
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63476902!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/MyPage/ChildInfo/PageForm.vue
// module id = 708
// module chunks = 0